<template>
  <w-button
    class="btn-light mr-2 mb-1"
    :class="action.class"
    :icon="action.icon"
    :text="action.tooltipText || action.name"
    :style="{ color: actionColor }"
    @click="$emit(action.event, { object, action })"
  />
</template>

<script>
import { actionMixin } from '@/mixins/action';

// @vuese
// Pojedyncza akcja
// @group Components
export default {
  mixins: [actionMixin],
  props: {
    // Typ encji
    entityType: { type: String, required: false }
  },

  computed: {
    // @vuese
    // Encja struktury
    secretaryEntity() {
      const nodeId = this.object?.data?.school?.nodeId;
      if (nodeId) {
        return `structure_node:${nodeId}`;
      }
    },

    // @vuese
    // Encja procedury
    operatorEntity() {
      const procedureId = this.object?.procedureId;
      if (procedureId) {
        return `procedure:${procedureId}`;
      }
    },

    // @vuese
    // Uprawnienia do przycisku nie dla autora
    nonAuthorPermissions() {
      const entities = [this.secretaryEntity, this.operatorEntity];
      return entities.filter(Boolean).map(entity => `BUTTON.USE:${entity}`);
    }
  }
};
</script>
